import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slide", "item"];

  connect() {
    if (this.slideTarget && this.itemTarget) {
      const clone = this.itemTarget.cloneNode(true);
      this.slideTarget.appendChild(clone);
    }
  }
}
